import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

function LandingIcon({ children, title, text }) {
    return (
        <Card>
            <Box p={2}>
                <Grid container justifyContent='center'>
                    <Grid item xs={2}>
                        {children}
                    </Grid>
                </Grid>

                <CardContent>
                    <Grid container justifyContent='center'>
                        <Typography component='h6' variant='h6'>
                            {title}
                        </Typography>
                        <Typography variant='subtitle1' color='textSecondary' align='center'>
                            {text}
                        </Typography>
                    </Grid>
                </CardContent>
            </Box>
        </Card>
    );
}

export default LandingIcon;
